/**********************************************************************************************************
 *   BASE IMPORTS
 **********************************************************************************************************/
import styled from 'styled-components'

/**********************************************************************************************************
 *   SHARED IMPORTS
 **********************************************************************************************************/
import { Theme } from '@nexigendigital/nxui'
import { Weight } from 'models/enums'
import { useAppSelector } from 'store/hooks'
import { aud } from 'helpers/utils'

/**********************************************************************************************************
 *   COMPONENT START
 **********************************************************************************************************/
export default function CartSummary() {
    const { total, cart } = useAppSelector((state) => state.shop)

    if (!cart) {
        return (
            <StyledCartSummary>
                <Discount>
                    <div>
                        <div>Subtotal</div>
                        <div>{aud(total / 100)}</div>
                    </div>
                    <div>
                        <div>Discount</div>
                        <div>{aud(0)}</div>
                    </div>
                </Discount>
                <Total>
                    <div>Total</div>
                    <div>{aud(total / 100)}</div>
                </Total>
            </StyledCartSummary>
        )
    }

    return (
        <StyledCartSummary>
            <Discount>
                <div>
                    <div>Subtotal</div>
                    <div>{aud(cart.pricing.subtotal)}</div>
                </div>
                <div>
                    <div>Discount</div>
                    <div>{aud(cart.pricing.total_discount)}</div>
                </div>
            </Discount>
            <Total>
                <div>Total</div>
                <div>{aud(cart.pricing.total)}</div>
            </Total>
        </StyledCartSummary>
    )
}

/**********************************************************************************************************
 *   CUSTOM STYLING
 **********************************************************************************************************/
const StyledCartSummary = styled.div`
    min-width: 398px;
    font-size: .875rem;
    ${Theme.Functions.setFont('Inter', Weight.SemiBold)};

    ${props => (Theme.Functions.mediaBreakDown(props.theme['breakpoints-sm']))} {
        width: 100%;
        min-width: initial;
    }

    > div {
        padding: 20px 24px;
        display: flex;
    }
`

const Discount = styled.div`
    flex-direction: column;
    gap: 16px;
    border: 1px solid ${props => props.theme['gray--100']};
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
    border-bottom: none;
    color: ${props => props.theme['text--100']};
    background-color: ${props => props.theme['background--100']};

    > div {
        display: flex;
        justify-content: space-between;
    }
`

const Total = styled.div`
    justify-content: space-between;
    border: 1px solid ${props => props.theme['gray--100']};
    border-bottom-left-radius: 16px;
    border-bottom-right-radius: 16px;
    border-top: none;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
    color: ${props => props.theme['text--300']};
`
